export function ErrorRetryCard({ message, onRetry }) {
  return (
    <div role="alert" className="bg-error-container/40 border border-error/30 rounded-lg p-4 text-center space-y-3">
      <p className="text-sm text-on-surface">{message}</p>
      <button
        onClick={onRetry}
        className="px-4 py-2 bg-error/10 text-error border border-error/30 font-bold rounded hover:bg-error/20 transition-colors text-sm"
      >
        Tentar novamente
      </button>
    </div>
  );
}
